const arrayUnionNoDuplicates = (array1, array2, duplicateProperty) => {
  const safeArray1 = Array.isArray(array1) ? array1 : []
  const safeArray2 = Array.isArray(array2) ? array2 : []

  const map = new Map()
  safeArray1.forEach(item => map.set(item[duplicateProperty], item))
  safeArray2.forEach(item => map.set(item[duplicateProperty], item))
  return Array.from(map.values())
}

export default arrayUnionNoDuplicates
